import { createAction, props } from '@ngrx/store';
import { ScheduleUiSettings } from '../models/schedule.model';

// Load Schedule UI Settings
export const loadScheduleUiSettings = createAction(
  '[Schedule UI Settings] Load Schedule UI Settings', 
  props<{ organizationId: string }>()
);

export const loadScheduleUiSettingsSuccess = createAction(
  '[Schedule UI Settings] Load Schedule UI Settings Success', 
  props<{ uiSettings: ScheduleUiSettings }>()
);

export const loadScheduleUiSettingsFailure = createAction(
  '[Schedule UI Settings] Load Schedule UI Settings Failure', 
  props<{ error: any }>()
);